import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
Vue.use(Vuex)

function safeParseUserInfo() {
	try {
		const raw = localStorage.getItem('userInfo')
		if (!raw) return null
		return JSON.parse(raw)
	} catch (e) {
		try {
			localStorage.removeItem('userInfo')
		} catch (err) {}
		return null
	}
}

const state={
	userInfo: safeParseUserInfo(),
	Loading:false,
	selectedRecorded:[],
	videoUrl:'',
	recording:[],		//录播数组
	wxShare:{},     //微信分享 
	meeting_id:''   //会议id

}
export default new Vuex.Store({
	state,
	actions,
	mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js